import React, { useEffect, useState } from "react";
import { ContentWrapper, WrapperCard } from "@components/index";
import { useNavigate, useParams } from "react-router-dom";
import { Space, Typography, Tabs, Row, Col, Button } from "antd";

import styles from "../../../Contract.module.scss";
import { Icon } from "@iconify/react";
import { useNotification } from "@hooks/useNotification";
import { isEmpty, map } from "lodash";
import moment from "moment";
import { get } from "~/Services";
import { useAuth } from "@hooks/useAuth";

const getItemText = (name?: string, value?: any, isBoolean?: any) => {
  return (
    <Space
      direction="vertical"
      style={{ marginBottom: styles.whitespace4, paddingRight: "20px" }}
    >
      <Typography.Text type="secondary">{name}</Typography.Text>
      <Typography.Text>{!isBoolean ? value : value === "true" ? "Enabled" : "Disabled"}</Typography.Text>
    </Space>
  );
};

export const TemplatesDrilldown = (props: any) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { openToast } = useNotification();
  const [data, setData] = useState<{ [key in string]: any }>({});
  const { user } = useAuth();

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      get(`v1/spa/template-detail?templateId=${id}`)
        .then((res: any) => {
          if (res) {
            let tempData = res.response.data;
            setData(tempData);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          openToast({ content: err, type: "error" });
        });
    }
  }, []);

  if (isEmpty(data)) {
    return <ContentWrapper loading={isLoading}> </ContentWrapper>;
  }

  return (
    <>
      <ContentWrapper
        loading={isLoading}
        customTitle={
          <Space style={{ alignItems: "center", lineHeight: 1 }}>
            <Icon
              onClick={() => navigate(`/templates`)}
              icon="akar-icons:arrow-left"
              style={{
                fontSize: "1.8rem",
                cursor: "pointer",
                color: styles.primary,
                marginRight: styles.whitespace1,
              }}
            />
            <Typography.Title
              level={3}
              style={{ margin: 0 }}
            >
              Template Details
            </Typography.Title>
          </Space>
        }
      >
        <Row>
          <Col
            span={24}
            style={{ marginBottom: styles.whitespace3 }}
          >
            <WrapperCard
              title="Template Details"
              smallHeader
              action={
                <Icon
                  icon="carbon:edit"
                  style={{
                    color: styles.strawberry,
                    cursor: "pointer",
                    fontSize: 20,
                    verticalAlign: "middle",
                  }}
                  onClick={() => navigate(`/templates/edit/${id}`)}
                />
              }
            >
              <Row gutter={16}>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText("Template Name", data?.templateName)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Review Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.reviewMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.reviewMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Approved Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.approveMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.approveMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Completed Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.completeMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.completeMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Declined Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.declineMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.declineMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Reminder Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.reminderMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.reminderMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Copy Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.copyMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.copyMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Expiry Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.expiryMail?.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.expiryMail?.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Higher Authority Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.higherAuthorityMail?.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.higherAuthorityMail?.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>SPA Creator Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.creatorMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.creatorMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Re-Submit Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.reSubmitMail.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.reSubmitMail.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Typography.Title level={5}>Cancel Email</Typography.Title>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(" Email Subject", data?.cancelMail?.emailSubject)}
                </Col>
                <Col
                  xs={24}
                  md={16}
                >
                  {getItemText("Email Message", data?.cancelMail?.emailMessage)}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={24}
                >
                  <Typography.Title
                    level={4}
                    style={{ margin: 4, marginLeft: 0 }}
                  >
                    Custom Options
                  </Typography.Title>
                </Col>
                <Col
                  xs={24}
                  md={24}
                >
                  <Typography.Title
                    level={5}
                    style={{ margin: 2 }}
                  >
                    Reminders
                  </Typography.Title>
                </Col>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(
                    "Send Automatic Reminders",
                    data?.reminder?.reminderEnabled == true ? "Enabled" : "Disabled"
                  )}
                </Col>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(
                    "Days until first reminder",
                    data?.reminder?.reminderEnabled ? data?.reminder?.reminderFrequency + " day(s)" : "-"
                  )}
                </Col>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(
                    "Days between reminder",
                    data?.reminder?.reminderEnabled ? data?.reminder?.reminderDelay + " day(s)" : "-"
                  )}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={24}
                >
                  <Typography.Title
                    level={5}
                    style={{ margin: 4, marginLeft: 0 }}
                  >
                    Expiration
                  </Typography.Title>
                </Col>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(
                    "Document will expire on",
                    moment().add(Number(data?.expiration?.expiryAfter), "days").format("DD MMM YYYY")
                  )}
                </Col>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText("Days to warn approvers before expiration", data?.expiration?.expiryWarn + " day(s)")}
                </Col>
              </Row>
              <Row>
                <Col
                  xs={24}
                  md={24}
                ></Col>
                {/* <Col
                  xs={24}
                  md={12}
                >
                  {getItemText(
                    "Responsive Signing for mobile-friendly viewing",
                    data.signerCanSignOnMobile,
                    true
                  )}
                </Col> */}
                {/* <Col
                  xs={24}
                  md={12}
                >
                  {getItemText("Comments", data.allowComments, true)}
                </Col> */}
              </Row>
              <Row>
                {/*  <Col*/}
                {/*    xs={24}*/}
                {/*    md={24}*/}
                {/*  >*/}
                {/*    <Typography.Title*/}
                {/*      level={5}*/}
                {/*      style={{ margin: 4, marginLeft: 0 }}*/}
                {/*    >*/}
                {/*      Recipient Privileges*/}
                {/*    </Typography.Title>*/}
                {/*  </Col>*/}
                {/*  <Col*/}
                {/*    xs={24}*/}
                {/*    md={12}*/}
                {/*  >*/}
                {/*    {getItemText(*/}
                {/*      "Restrict sender from editing, adding, or removing recipients",*/}
                {/*      data.recipientsLock,*/}
                {/*      true*/}
                {/*    )}*/}
                {/*  </Col>*/}
                {/*  <Col*/}
                {/*    xs={24}*/}
                {/*    md={12}*/}
                {/*  >*/}
                {/*    {getItemText(*/}
                {/*      "Restrict sender from editing subject, email, or private message",*/}
                {/*      data.messageLock,*/}
                {/*      true*/}
                {/*    )}*/}
                {/*  </Col>*/}
                <Col
                  span={24}
                  style={{ marginBottom: styles.whitespace3 }}
                >
                  {/* <ContractDocument title="Documents" documents={docsList} id={id} type={"template"} /> */}
                </Col>
              </Row>
              <Col span={24}></Col>
            </WrapperCard>
          </Col>
        </Row>
      </ContentWrapper>
    </>
  );
};
